import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {MenuService} from '../../../services/menu.service';
import {ModuleService} from '../../../services/module.service';
import {HttpErrorResponse} from '@angular/common/http';
import {PermissionService} from '../../../services/permission.service';

@Component({
  selector: 'app-menu-edit',
  templateUrl: './menu-edit.component.html',
  styleUrls: ['./menu-edit.component.scss']
})
export class MenuEditComponent implements OnInit{

  menuForm: FormGroup;
  modules: any[] = [];
  permissions: any[] = [];

  public types: any[] = [
    {id: 1, name: 'sub', title: 'menu'}
  ];

  selectedBadgeTypes: string | undefined;

  public badgeTypes: any[] = [
    {id: 1, name: 'light-primary'},
    {id: 2, name: 'light-secondary'},
  ];

  moduleSelected: number | undefined;
  typeSelected: string | undefined;

  saving = false;
  savingAndNew = false;
  status = false;

  waitingModule = false;
  waitingChildren = false;
  loading = 'Loading...';


  public data: any;

  isSubmitted = false;
  val: any | null;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private menuService: MenuService,
              private moduleService: ModuleService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    this.menuForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      icon: [''],
      type: ['', [Validators.required]],
      module: ['', [Validators.required]],
      position: [''],
      badgeType: [''],
      badgeValue: [''],
      title: this.types[0]["title"],
      isEnable: '',
    });

  }

  ngOnInit(): void {
    this.menuForm.get('isEnable')?.setValue('1');
    this.waitingModule = true;
    this.waitingChildren = true;
    this.menuForm.patchValue(this.data);
    console.log(this.data);

    this.moduleSelected = this.data.module['@id'];
    //this.typeSelected = this.data.type;
    this.menuForm.get('isEnable')?.setValue(this.data.isEnable ? '1' : '0');
    this.selectedBadgeTypes = this.data.badgeType;
    this.findAllModule();
    this.typeSelected = 'sub';
  }


  get fc(): any {
    return this.menuForm.controls;
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    if (this.menuForm.valid){
      this.saving = true;
      if (this.data){
        this.menuForm.get('isEnable')?.setValue(this.menuForm.get('isEnable')?.value === '1');
        this.menuService.putMenu(this.data.id, this.menuForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Menu edit with success !', 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
            this.savingAndNew = false;
          },
          error: (err: any) =>
          {
            console.log(err);
            const errors: any[] = err.violations;

            if (errors){
              errors.forEach((v) =>
              {
                if (v.propertyPath === 'module'){
                  this.menuForm.get('module')?.setErrors({serverError: v.message});
                }
                console.log(v.message);
                if (v.propertyPath === 'name'){
                  this.menuForm.get('name')?.setErrors({serverError: v.message});
                }

                this.saving = false;
                this.savingAndNew = false;

              });
            }
            else {
              this.toastr.error(err['hydra:title'], 'Error');
              this.saving = false;
              this.savingAndNew = false;
            }

          }
        });
      }


    }
  }


  findAllModule() {
    this.moduleService.getEnableCollection().subscribe({
      next: (data: any) => {
        console.log(data['hydra:member']);
        this.modules = data['hydra:member'];
        if (this.modules){
          this.modules = this.modules.map((v) => {
            v.id = v['@id'];
            return v;
          });
          this.waitingModule = false;
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

}
